// extracted by mini-css-extract-plugin
export default {"buttons-container":"tutor-buttons_buttons-container__UaJAl"};